import React, { useState, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Container as ContainerBase } from "components/misc/Layouts";
import { CallApiFetchAuthorized } from "helpers/CallApiFetch";
import tw from "twin.macro";
import styled from "styled-components";
import AdminHeader from 'pages/Admin/Header.js';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Container = tw(ContainerBase)`min-h-screen bg-primary-900 text-white font-medium flex justify-center`;
const Content = tw.div`max-w-screen-xl bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1 sm:my-8 sm:mx-1`;
const MainContainer = tw.div`p-6 sm:p-12`;
const MainContent = tw.div`mt-4 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;

const Form = tw.form`mx-auto max-w-xs pt-8`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5`;
const BirthDateRow = tw.div`flex gap-2 mt-5`;
const BirthSelect = tw.select`flex-1 px-4 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 text-sm focus:outline-none focus:border-gray-400 focus:bg-white`;
const Textarea = tw.textarea`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 resize-y`;

const SubmitButton = styled.button`
  ${tw`mt-5 font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all`}
`;

const Error = tw.p`font-medium bg-red-300 text-center p-4 mt-8`;

const onlyCountries = ['af','al','dz','ad','ao','ag','ar','am','aw','au','at','az','bs','bh','bd','bb','by','be','bz','bj','bt','bo','ba','bw','br','io','bn','bg','bf','bi','kh','cm','ca','cv','bq','cf','td','cl','cn','co','km','cd','cg','cr','ci','hr','cu','cw','cy','cz','dk','dj','dm','do','ec','eg','sv','gq','er','ee','et','fj','fi','fr','gf','pf','ga','gm','ge','de','gh','gr','gd','gp','gu','gt','gn','gw','gy','ht','hn','hk','hu','is','in','id','ir','iq','ie','il','it','jm','jp','jo','kz','ke','ki','xk','kw','kg','la','lv','lb','ls','lr','ly','li','lt','lu','mo','mk','mg','mw','my','mv','ml','mt','mh','mq','mr','mu','mx','fm','md','mc','mn','me','ma','mz','mm','na','nr','np','nl','nc','nz','ni','ne','ng','kp','no','om','pk','pw','ps','pa','pg','py','pe','ph','pl','pt','pr','qa','re','ro','rw','kn','lc','vc','ws','sm','st','sa','sn','rs','sc','sl','sg','sk','si','sb','so','za','kr','ss','es','lk','sd','sr','sz','se','ch','sy','tw','tj','tz','th','tl','tg','to','tt','tn','tr','tm','tv','ug','ua','ae','gb','us','uy','uz','vu','va','ve','vn','ye','zm','zw'];

const months = [
  { value: '01', label: 'Январь' },
  { value: '02', label: 'Февраль' },
  { value: '03', label: 'Март' },
  { value: '04', label: 'Апрель' },
  { value: '05', label: 'Май' },
  { value: '06', label: 'Июнь' },
  { value: '07', label: 'Июль' },
  { value: '08', label: 'Август' },
  { value: '09', label: 'Сентябрь' },
  { value: '10', label: 'Октябрь' },
  { value: '11', label: 'Ноябрь' },
  { value: '12', label: 'Декабрь' },
];

function getDaysInMonth(year, month) {
  if (!year || !month) return [];
  const count = new Date(year, month, 0).getDate();
  return Array.from({ length: count }, (_, i) =>
    String(i + 1).padStart(2, '0')
  );
}

export default ({ a14n = null }) => {
  const { secret } = useParams();

  const [error, setError] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(true);

  const [name, setName] = useState('');
  const [phid, setPhid] = useState('');
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');

  const [birthYear, setBirthYear] = useState('');
  const [birthMonth, setBirthMonth] = useState('');
  const [birthDay, setBirthDay] = useState('');

  useEffect(() => {
    CallApiFetchAuthorized(
      '/api/tickets/' + secret,
      null,
      a14n.token
    ).then(result => {
      if (!result.success) {
        setError(result.message);
        setLoading(false);
        return;
      }

      const data = result.data;

      setName(data.name || '');
      setPhid(data.id || '');
      setPhone(data.phone || '');
      setDescription(data.description || '');

      if (data.birth_date) {
        const [y, m, d] = data.birth_date.split('-');
        setBirthYear(y);
        setBirthMonth(m);
        setBirthDay(d);
      }

      setLoading(false);
    });
  }, [secret, a14n.token]);

  function SubmitHandler(event) {
    event.preventDefault();

    const birth_date =
      birthYear && birthMonth && birthDay
        ? `${birthYear}-${birthMonth}-${birthDay}`
        : null;

    const data = {
      name,
      birth_date,
      phid,
      phone,
      description: description || null,
    };

    CallApiFetchAuthorized(
      '/api/tickets/edit/' + secret,
      data,
      a14n.token
    ).then(result => {
      if (result.success) {
        setRedirect('/ticket/' + secret);
        setError(false);
      } else {
        setError(result.message);
      }
    });
  }

  if (redirect) {
    return <Navigate to={redirect} />;
  }

  return (
    <>
      <AdminHeader a14n={a14n} />
      <Container>
        <Content>
          <MainContainer>
            <MainContent>
              <Heading>Редактировать абонемент</Heading>

              {!loading && (
                <Form onSubmit={SubmitHandler}>
                  <Input
                    name="name"
                    placeholder="Имя посетителя"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required
                  />

                  <BirthDateRow>
                    <BirthSelect value={birthYear} onChange={e => setBirthYear(e.target.value)}>
                      <option value="">Год</option>
                      {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() - 4 - i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </BirthSelect>

                    <BirthSelect value={birthMonth} onChange={e => setBirthMonth(e.target.value)}>
                      <option value="">Месяц</option>
                      {months.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                      ))}
                    </BirthSelect>

                    <BirthSelect value={birthDay} onChange={e => setBirthDay(e.target.value)}>
                      <option value="">День</option>
                      {getDaysInMonth(birthYear, birthMonth).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </BirthSelect>
                  </BirthDateRow>

                  <Input
                    name="phid"
                    placeholder="Физический номер карты"
                    value={phid}
                    onChange={e => setPhid(e.target.value)}
                    required
                  />

                  <PhoneInput
                    country="kz"
                    onlyCountries={onlyCountries}
                    value={phone}
                    onChange={setPhone}
                    inputProps={{ required: true }}
                    containerStyle={{ marginTop: '1.25rem' }}
                  />

                  <Textarea
                    name="description"
                    rows={4}
                    placeholder="Комментарий"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                  />

                  <SubmitButton>Сохранить</SubmitButton>

                  {error && <Error>{error}</Error>}
                </Form>
              )}
            </MainContent>
          </MainContainer>
        </Content>
      </Container>
    </>
  );
};